export default __webpack_public_path__ + "static/media/king.a4d8a882.png";